import React from 'react';
import { MenuLevel } from '../models';
import Icon from '@lib/components/Icon';
import { TextBlock } from './TextBlock';

interface MegaMenuElementProps {
    activePath: number[];
    isActive: boolean;
    element: MenuLevel;
    level: number;
    onActivate: (path: number[]) => void;
}

export default class MegaMenuElement extends React.Component<MegaMenuElementProps> {
    render(): JSX.Element | null {
        const { level, element, activePath, isActive } = this.props;

        const activeClass = isActive && activePath.length === level ? 'is-active' : '';
        const renderedElement = element.href ? (
            // eslint-disable-next-line react/jsx-no-target-blank
            <a
                className={`mega-menu__link ${activeClass}`}
                href={element.href}
                onMouseEnter={() => this.props.onActivate([])}
                onFocus={() => this.props.onActivate([])}
                target={element.external ? '_blank' : undefined}
                rel={element.external ? 'noopener noreferrer' : undefined}
            >
                <TextBlock text={element.text} />
                {element.external ? (
                    <Icon className="is-external-link-icon" icon="external-link" />
                ) : element.extra ? (
                    <Icon icon="arrow-right" />
                ) : (
                    <Icon icon="" />
                )}
            </a>
        ) : (
            <span
                tabIndex={0}
                className={`mega-menu__link ${activeClass}`}
                onMouseEnter={() => this.props.onActivate([])}
                onFocus={() => this.props.onActivate([])}
            >
                {element.extra ? (
                    <>
                        <TextBlock text={element.text} />
                        <Icon icon="arrow-right" />
                    </>
                ) : (
                    <span>{element.text}</span>
                )}
            </span>
        );

        return (
            <div className={`mega-menu__list is-level-${level}`}>
                {renderedElement}
                {Array.isArray(element.children) && (
                    <div className="mega-menu__list-children">
                        {element.children.map((child, index) => (
                            <MegaMenuElement
                                key={index}
                                element={child}
                                level={level + 1}
                                onActivate={(e) => this.onActivate(index, e)}
                                isActive={isActive && activePath[level] === index}
                                activePath={activePath}
                            />
                        ))}
                    </div>
                )}
            </div>
        );
    }

    onActivate(index: number, path: number[]): void {
        this.props.onActivate([index, ...path]);
    }
}
